import { render, staticRenderFns } from "./D006.vue?vue&type=template&id=04969cf6&scoped=true&"
import script from "./D006.vue?vue&type=script&lang=js&"
export * from "./D006.vue?vue&type=script&lang=js&"
import style0 from "./D006.vue?vue&type=style&index=0&id=04969cf6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04969cf6",
  null
  
)

export default component.exports